import { createApp, } from 'vue'
import App from './getHelp.vue'

const app = createApp(App);
app.mount("#app");
